import AddIcon from '@mui/icons-material/Add';
import {Button, Checkbox, Dialog, DialogContent, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";

export default class Roles extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            filter: {
                limit: 10,
                offset: 0
            },
            roles: [],
            total: 0,
            menuList: [],
            popup: {
                open: false,
                role: {
                    name: "",
                    menus: [],
                    focusId: ""
                }
            }
        };
    }

    componentDidMount() {
        this.fetchRoles();
    }

    fetchRoles = async () => {
        const url = `${Config.getInstance.apiUrl}/api/roles`;
        const headers = {Authorization: Helpers.getSessionId()};

        const response = await axios.get(url, {headers});

        const success = response.data.success;
        if (success) {
            this.setState({
                roles: response.data.roles,
                total: response.data.total,
                menuList: response.data.menuList,
            });
        } else {
            PopupMessage.error(`Failed to fetch roles`);
        }
    }

    onAddRole = () => {
        const {popup} = this.state;

        popup.open = true;

        //Reset data
       popup.role = {
            name: "",
            menus: [],
            focusId: ""
        };

        this.setState({popup});
    }

    onClosePopup = () => {
        const {popup} = this.state;

        popup.open = false;
        this.setState({popup});
    }

    onChangeRoleName = (event: any) => {
        const {popup} = this.state;

        // Uppercase all letters
        popup.role.name = event.target.value.toUpperCase();
        this.setState({popup});
    }

    onChangeMenu = (event: any, menuId: string) => {
        const {popup} = this.state;

        if (event.target.checked) {
            popup.role.menus.push(menuId);
        } else {
            popup.role.menus = popup.role.menus.filter((id: string) => id !== menuId);
        }

        this.setState({popup});
    }

    onSubmit = async () => {
        const {popup} = this.state;

        const {name, menus, focusId} = popup.role;

        let url = `${Config.getInstance.apiUrl}/api/roles`;

        if (focusId) {
            url += `/${focusId}`;
        }

        const headers = {Authorization: Helpers.getSessionId()};

        const data = {name, menus};

        const response = await axios.post(url, data, {headers});

        const success = response.data.success;

        if (success) {
            PopupMessage.success(`Role has been saved`);
            this.onClosePopup();
            this.fetchRoles();
        } else {
            PopupMessage.error(`Failed to save role`);
        }
    }

    onEditRole = (role: any) => {
        const {popup} = this.state;

        popup.open = true;
        popup.role = role;
        popup.role.focusId = role.id;
        this.setState({popup});
    }

    onDeleteRole = async (role: any) => {
        // Confirm
        if (!window.confirm(`Are you sure you want to delete role: ${role.name}`)) {
            return;
        }

        const url = `${Config.getInstance.apiUrl}/api/roles/${role.id}`;
        const headers = {Authorization: Helpers.getSessionId()};

        const response = await axios.delete(url, {headers});

        const success = response.data.success;

        if (success) {
            PopupMessage.success(`Role has been deleted`);
            this.fetchRoles();
        } else {
            PopupMessage.error(`Failed to delete role`);
        }
    }

    renderPopup = () => {
        const {popup, menuList} = this.state;

        return <Dialog
            open={popup.open}
            onClose={() => this.onClosePopup()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogTitle>{popup.name ? `Edit` : `Create`} Role</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item container sm={12}>
                        <Grid item sm={3}>
                            <Typography>Name: </Typography>
                        </Grid>

                        <Grid item sm={9}>
                            <TextField
                                value={popup.role.name}
                                onChange={(event) => this.onChangeRoleName(event)}
                                fullWidth
                            />
                        </Grid>

                    </Grid>

                    <Grid item container sm={12}>
                        <Grid item sm={3}>
                            <Typography>Menus: </Typography>
                        </Grid>

                        <Grid item sm={9}>
                            {
                                // a list of tick boxes for menus
                                menuList.map((menu: any, index: number) => {
                                    return <Grid key={index} container>
                                        <Grid item sm={3}>
                                            <Typography>{menu}</Typography>
                                        </Grid>

                                        <Grid item sm={9}>
                                            <Checkbox
                                                checked={popup.role.menus.includes(menu)}
                                                onChange={(event) => this.onChangeMenu(event, menu)}
                                            />
                                        </Grid>
                                    </Grid>
                                })
                            }
                        </Grid>
                    </Grid>

                    <Grid item container sm={12} justifyContent="flex-end" spacing={1}>
                        <Grid item sm={1}>
                            <Button
                                color='error'
                                variant="contained"
                                onClick={() => this.onClosePopup()}
                            >
                                Cancel
                            </Button>
                        </Grid>

                        <Grid item sm={1}>
                            <Button
                                variant="contained"
                                onClick={() => this.onSubmit()}
                            >
                                Submit
                            </Button>
                        </Grid>



                    </Grid>

                </Grid>
            </DialogContent>

        </Dialog>
    }

    renderPanel = () => {

        return <Paper>

        </Paper>
    }

    renderRoles = () => {
        const {roles} = this.state;

        return <Table>
            <TableHead>
                <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Menus</TableCell>
                    <TableCell>Created</TableCell>
                    <TableCell>Updated</TableCell>
                    <TableCell width={"5%"}>
                        <Button
                            variant="contained"
                            onClick={() => this.onAddRole()}
                        >
                            <AddIcon />
                            Create
                        </Button>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    roles.map((role: any, index: number) => {
                        return <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{role.name}</TableCell>
                            <TableCell>{role.menus.join(", ")}</TableCell>
                            <TableCell>{role.created_at}</TableCell>
                            <TableCell>{role.updated_at}</TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    onClick={() => this.onEditRole(role)}
                                >
                                    Edit
                                </Button>
                            </TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={() => this.onDeleteRole(role)}
                                >
                                    Delete
                                </Button>
                            </TableCell>
                        </TableRow>
                    })
                }
            </TableBody>
        </Table>
    }

    render() {
        return (
            <Paper className="contentPadding" style={{width: "100%"}}>
                <Typography variant="h4">Roles</Typography>
                {this.renderPopup()}
                {this.renderRoles()}
            </Paper>
        );
    }
}